import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            <i className="ri-grid-line text-primary-500 mr-2"></i>
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型浏览，找到你喜欢的漫画</p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colorClass = cat.color === 'primary'
              ? 'bg-primary-50 text-primary-700 hover:bg-primary-100 border-primary-200'
              : cat.color === 'accent'
                ? 'bg-accent-50 text-accent-700 hover:bg-accent-100 border-accent-200'
                : 'bg-secondary-50 text-secondary-700 hover:bg-secondary-100 border-secondary-200';

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl border transition-all duration-300 hover:-translate-y-1 ${colorClass}`}
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium whitespace-nowrap">{cat.name}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}